import { createSelector } from 'reselect';
import type { ModalTypes } from '../../../model/modals/types';
import type { State } from '../../types';

export const getOpenModalData = (state: State) => state.ui.modals;
export const makeIsModalOpen = createSelector([getOpenModalData], (modalData) => {
	const isModalOpen = (modalType: ModalTypes): boolean =>
		modalData !== null && modalData.type === modalType;

	return isModalOpen;
});

export const isAnyModalOpen = createSelector([getOpenModalData], (modalData) => modalData !== null);
